import styled from "styled-components";

export const Container = styled.div`
  background-color: white;
  border-radius: 3px;
  padding: 15px;
  line-height: 1.5em;
  font-size: 15px;
  box-shadow: 0px 0px 1px #888;
  min-height: 115px;
  margin: 10px 1px;
  overflow: hidden;
  position: relative;
  text-align: left;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const RowCenter = styled(Row)`
  justify-content: center;
  align-items: center;
`;
export const RowHeader = styled(Row)`
  margin-bottom: 5px;
`;

export const Col = styled.div`
  flex: 1;
`;

export const ColDropTime = styled(Col)`
  padding: 0 25px;
`;

export const Text = styled.div`
  font-family: "AvenirNext-Medium";
  font-size: 13px;
  font-weight: 500;
  line-height: 17px;
  text-align: left;
  color: #3b3b3b;
  margin-bottom: 5px;

  &.text-right {
    text-align: right;
  }
  &.text-center {
    text-align: center;
  }
  &.text-left {
    text-align: left;
  }
  &.text-blur {
    color: transparent;
    text-shadow: 0 0 10px rgba(0, 0, 0, 0.6);
  }
`;

export const TextError = styled(Text)`
  color: #fff;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  margin: 0;
  background: #d63031;
  padding: 5px 15px;
  box-sizing: border-box;
  text-align: center;
  font-size: 12px;
`;

export const Label = styled.label`
  font-family: "AvenirNext-DemiBold";
  font-size: 11px;
  font-weight: 600;
  color: #96979a;
  font-weight: normal;
`;

export const Title = styled.div`
  font-family: "AvenirNext-DemiBold";
  font-size: 16px;
  font-weight: 600;
  color: #4a4a4a;
`;

export const ModalContainer = styled.div`
  padding: 15px;
  min-width: 300px;
`;

export const ModalTitle = styled.div`
  font-family: "AvenirNext-DemiBold";
  font-size: 18px;
  font-weight: 900;
  text-align: center;
  color: #4a4a4a;
`;

export const ModalText = styled.div`
  text-align: center;
  color: #a4a4a4;
  margin: 20px 0;
`;

export const ModalAction = styled.div`
  text-align: center;
`;
